let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8gUF8")).then(() => parcelRequire('iQ7Zi'));